import type { KgInsightThemeType, ScreenerFilterOption } from '@api';

export interface SearchResult {
  id: string;
  name: string;
  type?: KgInsightThemeType;
}

interface GetSearchResultsOptions {
  defaultThemeOptions: ScreenerFilterOption[];
  isNewThemeSearchEnabled: boolean;
  isSearchActive: boolean;
  legacySearchData: ScreenerFilterOption[];
  newSearchData: SearchResult[];
}

const toSearchResult = (option: ScreenerFilterOption): SearchResult => ({
  id: option.value.id as string,
  name: option.name,
});

export const getSearchResults = ({
  defaultThemeOptions,
  isNewThemeSearchEnabled,
  isSearchActive,
  legacySearchData,
  newSearchData,
}: GetSearchResultsOptions): SearchResult[] => {
  if (isNewThemeSearchEnabled) {
    return newSearchData;
  }

  return isSearchActive
    ? legacySearchData.map(toSearchResult)
    : defaultThemeOptions.map(toSearchResult);
};

export const getIsThemeClickable = (
  type: KgInsightThemeType | undefined,
  isNewThemeSearchEnabled: boolean
) => isNewThemeSearchEnabled || type === undefined || type === 'industry';

export const toSelectedTheme = (
  item: SearchResult,
  isNewThemeSearchEnabled: boolean
) => ({
  id: item.id,
  name: item.name,
  isClickable: getIsThemeClickable(item.type, isNewThemeSearchEnabled),
  ...(isNewThemeSearchEnabled && item.type ? { type: item.type } : {}),
});

export const createHandlePillClick = <T extends { isClickable: boolean }>(
  onPillClick: ((theme: T) => void) | undefined,
  isNewThemeSearchEnabled: boolean
) => {
  if (!onPillClick) {
    return undefined;
  }

  return (theme: T) => () =>
    onPillClick(
      isNewThemeSearchEnabled ? { ...theme, isClickable: true } : theme
    );
};
